/** Check-in request + density query validators (plan 06 §3.2). */
import { z } from 'zod';

export const CheckinRequestSchema = z.object({
  location_id: z.string().uuid(),
  member_id: z.string().uuid(),
  source: z.enum(['app_qr', 'card', 'manual', 'turnstile']),
  scanned_at: z.string().datetime({ offset: true }),
  override_reason: z.string().max(500).optional(),
});

export const DensityQuerySchema = z.object({
  location_id: z.string().uuid(),
  granularity: z.enum(['hourly', 'daily', 'monthly']).default('hourly'),
  from: z.string().datetime({ offset: true }),
  to: z.string().datetime({ offset: true }),
});

export type CheckinRequestInput = z.infer<typeof CheckinRequestSchema>;
export type DensityQueryInput = z.infer<typeof DensityQuerySchema>;
